import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import { CONTAINER_TYPES } from '@src/quince-site-common/src/organisms/pageBuilder'

import { ProductSectionType } from '../../types/productPage.types'
import { MTE_ID } from '../constants'

export const MOBILE_PRODUCT_IMAGES = {
  id: 'MOBILE_PRODUCT_IMAGES',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.PRODUCT_IMAGES,
  },
}
export const MOBILE_PRODUCT_PURCHASE = {
  id: 'MOBILE_PRODUCT_PURCHASE',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.PRODUCT_PURCHASE,
  },
}
export const MOBILE_REVIEW_HIGHLIGHTS = {
  id: 'MOBILE_REVIEW_HIGHLIGHTS',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.REVIEW_HIGHLIGHTS,
  },
}
export const MOBILE_PRODUCT_DETAILS_AND_CARE = {
  id: 'MOBILE_PRODUCT_DETAILS_AND_CARE',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.PRODUCT_DETAILS_AND_CARE,
  },
}
export const MOBILE_BRAND_COMPARISON = {
  id: 'MOBILE_BRAND_COMPARISON',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.BRAND_COMPARISON,
  },
}
export const MOBILE_PAIR_WITH = {
  id: 'MOBILE_PAIR_WITH',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.PAIR_WITH,
  },
}
export const MOBILE_SIMILAR_PRODUCTS = {
  id: 'MOBILE_SIMILAR_PRODUCTS',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.SIMILAR_PRODUCTS,
  },
}
export const MOBILE_TRANSPARENT_PRICING = {
  id: 'MOBILE_TRANSPARENT_PRICING',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.TRANSPARENT_PRICING,
  },
}
export const MOBILE_INFLUENCER = {
  id: 'MOBILE_INFLUENCER',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.CUSTOM_SECTION,
    customSectionType: CUSTOM_SECTION_TYPE.INFLUENCER,
  },
}
export const MOBILE_INFORMATION_BOXES = {
  id: 'MOBILE_INFORMATION_BOXES',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.CUSTOM_SECTION,
    customSectionType: CUSTOM_SECTION_TYPE.INFORMATION_BOXES,
  },
}
export const MOBILE_FREQUENTLY_BOUGHT_TOGETHER = {
  id: 'MOBILE_FREQUENTLY_BOUGHT_TOGETHER',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.FREQUENTLY_BOUGHT_TOGETHER,
    mteId: MTE_ID,
  },
}
export const MOBILE_PRODUCT_REVIEWS = {
  id: 'MOBILE_PRODUCT_REVIEWS',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.PRODUCT_REVIEWS,
  },
}
export const MOBILE_YOU_MAY_ALSO_LIKE = {
  id: 'MOBILE_YOU_MAY_ALSO_LIKE',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.YOU_MAY_ALSO_LIKE,
  },
}

export const MOBILE_DISCLAIMER = {
  id: 'MOBILE_DISCLAIMER',
  containerType: CONTAINER_TYPES.SELF,
  props: {
    sectionType: ProductSectionType.DISCLAIMER,
  },
}
